export const wrapper = 'pb-20';
export const contentWrapper = 'px-4 pt-4 flex flex-col w-full mb-4';
export const dialogContent = 'h-full';
export const completeWrapper =
  'rounded-lg m-4 flex flex-row flex-nowrap bg-successMain items-center';
export const completeImage = 'mr-4 rounded-full p-4';
export const completeNotes = 'm-4';
export const languageWrapper =
  'w-full flex flex-row justify-start items-center';
